import React from "react";

import { Dialog } from "@tiny/components";
import SegmentSummary from "../SegmentSummary/SegmentSummary";

export interface SegmentSummaryDialogProps {
  open: boolean;
  onClose: () => void;
  filter: any;
  hideRefresh?: boolean;
  isFilterValid?: boolean;
  segmentId?: string;
}

function SegmentSummaryDialog(props: SegmentSummaryDialogProps) {
  const { open, onClose, filter, hideRefresh, isFilterValid, segmentId } =
    props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <SegmentSummary
        filter={filter}
        noBorderRadius
        onClose={onClose}
        hideRefresh={hideRefresh}
        isFilterValid={isFilterValid}
        segmentId={segmentId}
      />
    </Dialog>
  );
}

export default SegmentSummaryDialog;
